import { render } from "./ColumnDesignerModal.vue?vue&type=template&id=5a461802"
import script from "./ColumnDesignerModal.vue?vue&type=script&lang=js"
export * from "./ColumnDesignerModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__